import styles from './index.module.sass';
import { default as truckIcon } from '@/modules/mixing/images/logistics.svg';
import { default as spicaIcon } from '@/modules/common/icons/spica.icon.svg';
// import { default as priceIcon } from '@/modules/common/icons/price.icon.svg';
import { default as priceIcon } from '@/modules/common/icons/arrow.icon.svg';
import { WarehouseItem } from '@/modules/mixing/ts/index';
import { Tooltip } from 'antd';

export const StatsItem = ({ item }: IStatsItem) => {
  // для определения предельного круглого числа для показателей
  // чтобы взять за основу как 100% для линии графика
  const closestRoundNumber = (num: number) => {
    // const orderOfMagnitude = Math.floor(Math.log10(num));
    // const base = Math.pow(10, orderOfMagnitude);
    // const remainder = num % base;
    // let nearestRoundNumber;
    // if (remainder < base / 2) {
    //   nearestRoundNumber = Math.floor(num / base) * base;
    // } else {
    //   nearestRoundNumber = Math.ceil(num / base) * base;
    // }
    // console.log(num)
    // console.log(nearestRoundNumber)
    // return nearestRoundNumber;

    //v2
    // const strNum = Number(num).toString();
    // const length = strNum.length;
    // const closestGreaterNum = Math.pow(10, length);
    // return closestGreaterNum;

    //v3
    if (num === 0) return 0;
    const orderOfMagnitude = Math.pow(10, Math.floor(Math.log10(num)));
    return Math.ceil(num / orderOfMagnitude) * orderOfMagnitude;
  };

  // тут хранится число которое возьмем за 100%
  const lineMaxVal = closestRoundNumber(
    Math.max(item.cost_using_mixing, item.exchange, item.price_without_mixing),
  );

  function calculatePercentage(part: number, whole: number) {
    if (whole === 0) {
      return 1;
    }
    const percentage = (part / whole) * 100;
    const result = +percentage.toFixed();
    if (result <= 0) return 1;
    return result;
  }
  return (
    <li className={styles.statsItem}>
      <span className={styles.itemTitle}>
        {item.name}
        <Tooltip
          color="rgb(126, 137, 165)"
          title="Стоимость без миксования"
          trigger="hover"
        >
          <span className={styles.priceBadge} data-title="Стоимость без миксования">
            <img src={spicaIcon} className={styles.badgeImg} alt="icon" />
            {item.price_without_mixing?.toLocaleString('RU-ru', {
              maximumFractionDigits: 0,
            })}{' '}
            ₽
          </span>
        </Tooltip>

        <Tooltip
          color="rgb(102, 178, 138)"
          title="Стоимость с миксованием"
          trigger="hover"
        >
          <span className={styles.priceBadge} data-title="Стоимость с миксованием">
            <img src={priceIcon} className={styles.badgeImg} alt="icon" />
            {item.cost_using_mixing?.toLocaleString('RU-ru', {
              maximumFractionDigits: 0,
            })}{' '}
            ₽{' '}
            {item.cost_using_mixing > item.price_without_mixing &&
              `(+${item.res_sum_mix.toLocaleString('RU-ru', {
                maximumFractionDigits: 0,
              })} ₽)`}
          </span>
        </Tooltip>

        <Tooltip
          color="rgb(64, 155, 255)"
          title="Стоимость склада с учетом логистики (НЕТТО)"
          trigger="hover"
        >
          <span
            className={styles.priceBadge}
            data-title="Стоимость склада с учетом логистики (НЕТТО)"
          >
            <img src={truckIcon} className={styles.badgeImg} alt="icon" />
            {item?.price_logistic?.toLocaleString('RU-ru', {
              maximumFractionDigits: 0,
            }) || 0}{' '}
            ₽
          </span>
        </Tooltip>
      </span>
      <div className={styles.itemBody}>
        <div
          title={`Стоимость без миксования: ${item.price_without_mixing?.toLocaleString(
            'RU-ru',
            {
              maximumFractionDigits: 0,
            },
          )} ₽`}
          className={styles.dataLine}
        >
          <div
            className={styles.dataLineFiller}
            style={{
              backgroundColor: '#7E89A5',
              width:
                `${calculatePercentage(item.price_without_mixing, lineMaxVal)}%` ||
                '20%',
            }}
          ></div>
        </div>
        <div
          title={`Стоимость с миксованием: ${item.cost_using_mixing?.toLocaleString(
            'RU-ru',
            {
              maximumFractionDigits: 0,
            },
          )} ₽`}
          className={styles.dataLine}
        >
          <div
            className={styles.dataLineFiller}
            style={{
              backgroundColor: '#66B28A',
              width:
                `${calculatePercentage(item.cost_using_mixing, lineMaxVal)}%` || '20%',
            }}
          ></div>
        </div>
        <div
          title={`Стоимость склада с учетом логистики (НЕТТО): ${item.price_logistic?.toLocaleString(
            'RU-ru',
            {
              maximumFractionDigits: 0,
            },
          )} ₽`}
          className={styles.dataLine}
        >
          <div
            style={{
              backgroundColor: '#409BFF',
              width:
                `${calculatePercentage(item.price_logistic, lineMaxVal)}%` || '20%',
            }}
            className={styles.dataLineFiller}
          ></div>
        </div>
      </div>
    </li>
  );
};

interface IStatsItem {
  item: WarehouseItem;
}
